import { BaseTagFragment } from '../../../../generated/graphql.generated';

export const jobTagsInitialState = {
  tags: [] as BaseTagFragment[],
  tagSuggestions: [] as BaseTagFragment[],
  defaultTags: [] as BaseTagFragment[],
  tagsModified: false as boolean,
} as const;

export type JobTagsState = typeof jobTagsInitialState;
